import { render } from "./ReviewInspectionReport.vue?vue&type=template&id=ef1730ca&ts=true"
import script from "./ReviewInspectionReport.vue?vue&type=script&lang=ts"
export * from "./ReviewInspectionReport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__